export interface Shortcut {
  keys: string;
  description: string;
}

export const SHORTCUTS: readonly Shortcut[] = [
  { keys: "s", description: "Show/hide signatures panel" },
  { keys: "w", description: "Show/hide system panel" },
];
